import { render, staticRenderFns } from "./RossettoMenu.vue?vue&type=template&id=f434e5f6&"
import script from "./RossettoMenu.vue?vue&type=script&lang=js&"
export * from "./RossettoMenu.vue?vue&type=script&lang=js&"
import style0 from "./RossettoMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports